import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap';
import MotiliTextButton, {
    MotiliTextButtonGroup,
} from '../buttons/MotiliTextButton.jsx';

const CustomToggle = React.forwardRef(
    ({ children, onClick, disabled }, ref) => (
        <span
            ref={ref}
            onClick={e => {
                e.preventDefault();
                if (!disabled) {
                    onClick?.(e);
                }
            }}
            style={{ display: 'inline-flex' }}
        >
            <MotiliTextButton
                text={children}
                moStyle='action'
                size='md'
                disabled={disabled}
            />
        </span>
    )
);

CustomToggle.displayName = 'CustomToggle';

CustomToggle.propTypes = {
    children: PropTypes.node,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
};

TableActionsDropdown.propTypes = {
    title: PropTypes.string.isRequired,
    actions: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            onClick: PropTypes.func.isRequired,
            acls: PropTypes.bool,
            className: PropTypes.string,
            divider: PropTypes.bool,
        })
    ),
    busy: PropTypes.bool,
    disabled: PropTypes.bool,
    icon: PropTypes.node,
};

export default function TableActionsDropdown({
                                                 actions,
                                                 title,
                                                 busy,
                                                 disabled,
                                                 icon,
                                             }) {
    return (
        <MotiliTextButtonGroup busy={busy}>
            <Dropdown alignRight>
                <Dropdown.Toggle
                    as={CustomToggle}
                    id={`dropdown-${title}`}
                    disabled={disabled}
                >
                    {icon || <i className='fa fa-ellipsis-h' />}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    {actions.map((action, i) =>
                        action.divider ? (
                            <Dropdown.Divider key={`${i}-divider`} />
                        ) : (
                            <Dropdown.Item
                                key={i}
                                onClick={e => action.onClick(e)}
                                className={action.className}
                                disabled={action.acls === false}
                                style={{ borderBottom: 'none' }}
                            >
                                {action.name}
                            </Dropdown.Item>
                        )
                    )}
                </Dropdown.Menu>
            </Dropdown>
        </MotiliTextButtonGroup>
    );
}
